import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { MapPin } from "lucide-react";

interface LocationPreferencesProps {
  preferences?: {
    notifyForPrimaryOnly?: boolean | null;
    notifyForAllLocations?: boolean | null;
  } | null;
  onUpdate: (updates: Record<string, boolean>) => void;
}

export function LocationPreferences({ preferences, onUpdate }: LocationPreferencesProps) {
  return (
    <Card className="card-elevated border-none shadow-premium">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          Location Preferences
        </CardTitle>
        <CardDescription>
          Control which saved locations trigger notifications
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <Label htmlFor="notify-primary-only" className="flex-1 cursor-pointer">
            <div>
              <p className="font-medium">Primary location only</p>
              <p className="text-sm text-muted-foreground">
                Only receive notifications for your primary location
              </p>
            </div>
          </Label>
          <Switch
            id="notify-primary-only"
            checked={preferences?.notifyForPrimaryOnly ?? true}
            onCheckedChange={(checked) => {
              onUpdate({
                notifyForPrimaryOnly: checked,
                notifyForAllLocations: !checked,
              });
            }}
          />
        </div>

        <div className="flex items-center justify-between">
          <Label htmlFor="notify-all-locations" className="flex-1 cursor-pointer">
            <div>
              <p className="font-medium">All saved locations</p>
              <p className="text-sm text-muted-foreground">
                Receive notifications for all your saved locations
              </p>
            </div>
          </Label>
          <Switch
            id="notify-all-locations"
            checked={preferences?.notifyForAllLocations ?? false}
            onCheckedChange={(checked) => {
              onUpdate({
                notifyForAllLocations: checked,
                notifyForPrimaryOnly: !checked,
              });
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
}
